import React, {Component, Fragment} from 'react';
import { renderToString } from 'react-dom/server';

import moment from 'moment';

import './TripCarouselContent.css';
import Map from '../../../../../../../common/components/Map';
import { MarkerEmptyIcon } from '../../../../../../../common/icons';
import { MarkerOverRpmIcon } from '../../../../../../../common/icons';
import { MarkerTripStartIcon } from '../../../../../../../common/icons';
import { MarkerTripEndIcon } from '../../../../../../../common/icons';
import { inject, observer } from 'mobx-react';
import { api } from '../../../../../../../services';
import hereHelper from '../../../../../../../helpers/hereHelper';
import HereService from '../../../../../../../services/Here';

const DataColumn = ({ header1, value1, header2, value2 }) => (
  <div className="DataColumn">
    <div className="header">{header1}</div>
    <div className="value">{value1}</div>
    <div className="header">{header2}</div>
    <div className="value">{value2}</div>
  </div>
);

const serviceLevelsWithLimitedFeatures = ['light-a'];

@inject('translationsStore', 'commonStore')
@observer
export default class TripCarouselContent extends Component {
  constructor(props) {
    super(props);
    this.MapRef = React.createRef();

    this.MarkerEmptyIcon = renderToString(<MarkerEmptyIcon />);
    this.TripStartIcon = renderToString(<MarkerTripStartIcon style={{ color: 'var(--engine-on)' }} />);
    this.TripEndIcon = renderToString(<MarkerTripEndIcon style={{ color: 'var(--engine-off)' }} />);
    this.OverRpmIcon = renderToString(<MarkerOverRpmIcon />);

    this.state = {
      address1: '',
      address2: '',
      hasValidPosition: true,
      crashEvents: 0,
      positions: []
    };
  }

  matchroute() {
    if (this.props.positions && this.props.positions.length > 0) {
      this.setState({ positions: this.props.positions });

      const gpx = hereHelper.buildGpxForMatchroute(this.props.positions);
      return new HereService()
        .matchroute(gpx)
        .then(hereHelper.getPositionsFromMatchrouteResponse)
        .then(positions => new Promise(resolve => this.setState({ positions }, resolve)));
    } else {
      return new Promise(resolve => this.setState({ positions: [] }, resolve));
    }
  }

  componentDidMount = () => {
    //current.wrappedInstance if the component is wrapped by the mobx injector
    this.MapInstace = this.MapRef.current.wrappedInstance;
    this.matchroute();
    this.setCrashEvents();
    this.setAddresses();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.index !== this.props.index) {
      this.matchroute();
      this.setCrashEvents();
    }
    if (prevProps.trip !== this.props.trip) {
      this.setAddresses();
    }
  };

  setAddresses = async () => {
    this.setState({ address1: '...', address2: '...' });
    const {trip} = this.props;
    if (trip.positions && trip.positions.length > 0) {
      const startingPosition = trip.positions[0];
      const endingPosition = trip.positions[trip.positions.length - 1];

      if (startingPosition && endingPosition) {
        const hereService = new HereService();
        this.setState({
          hasValidPosition: true,
          address1: await hereService.retrieveAddress(startingPosition.loc[1], startingPosition.loc[0], 250),
          address2: await hereService.retrieveAddress(endingPosition.loc[1], endingPosition.loc[0], 250)
        });
      } else {
        this.setState({ hasValidPosition: false });
      }
    }
  }

  setCrashEvents = () => {
    const {
      plate,
      summary: { startAt, endAt }
    } = this.props;
    const startTime = startAt ? startAt : new Date().toISOString(),
      endTime = endAt ? endAt : new Date().toISOString();
    let crashEvents;
    api('getCarCrashEvents', plate, startTime, endTime)
      .then(response => {
        crashEvents = response.count;
      })
      .catch(() => {
        crashEvents = 0;
      })
      .finally(() => {
        this.setState({ crashEvents });
      });
  };

  markersMapper = (marker, index) => {
    const [lng, lat] = marker.coordinates;
    let markerData = {
      icon: marker.theme === 'start' ? this.TripStartIcon : marker.theme === 'end' ? this.TripEndIcon : marker.theme === 'overrpm' ? this.OverRpmIcon : this.MarkerEmptyIcon,
      lng,
      lat,
      id: marker.id
    };
    return markerData;
  };

  reverseGeocode = (lng, lat) => {
    return this.MapInstace.getMap().getAddressFromReverseGeocode({ lng, lat });
  };

  render() {
    const { summary, translationsStore, overRpmsWithPositions, serviceLevel } = this.props;
    const { hasValidPosition, crashEvents, positions } = this.state;

    let start = (positions && positions[0]) || [0, 0];
    let end = (positions && positions[positions.length - 1]) || [0, 0];

    let markers = [{ id: 0, theme: 'start', coordinates: start }, { id: 1, theme: 'end', coordinates: end }];
    overRpmsWithPositions.forEach(over => {
      const {
        startPosition: { lat, lng }
      } = over;
      markers.push({ id: markers.length, theme: 'overrpm', coordinates: [lng, lat] });
    });

    return (
      <div className="TripCarouselContent">
        <div className="data">
          <div className="summaries">
            <DataColumn
              header1={translationsStore.translate('tripsPanel.table.detail.minitrip')}
              value1={`${this.props.index + 1}/${this.props.total}`}
              header2={translationsStore.translate('tripsPanel.table.detail.hurshbrakes')}
              value2={summary.brakes}
            />
            <DataColumn
              header1={translationsStore.translate('tripsPanel.table.detail.distance')}
              value1={summary.distance + ' Km'}
              header2={translationsStore.translate('tripsPanel.table.detail.acceleration')}
              value2={summary.accelerations}
            />
            <DataColumn
              header1={translationsStore.translate('tripsPanel.table.detail.time')}
              value1={moment.duration(summary.duration, 'seconds').format('h:mm [h]', { trim: false })}
              header2={serviceLevelsWithLimitedFeatures.includes(serviceLevel) ? null : translationsStore.translate('tripsPanel.table.detail.overspeed')}
              value2={serviceLevelsWithLimitedFeatures.includes(serviceLevel) ? null : summary.overDrives}
            />
            {!serviceLevelsWithLimitedFeatures.includes(serviceLevel)  &&
            <Fragment>
              <DataColumn
                header1={translationsStore.translate('tripsPanel.table.detail.rating')}
                value1={summary.rating}
                header2={translationsStore.translate('tripsPanel.table.detail.crashevent')}
                value2={crashEvents}
              />
              <DataColumn header1={translationsStore.translate('tripsPanel.table.detail.overrpm')}
                          value1={summary.overRpms}/>
            </Fragment>
            }
          </div>
          <div className="border" />
          <div className="positionDescription">
            {positions && positions.length > 1 && (
              <div>
                <DataColumn header1={translationsStore.translate('tripsPanel.table.detail.journeystart')} value1={this.state.address1} />
                <DataColumn value1={new Date(summary.startAt).toLocaleTimeString([], {timeStyle: 'short'})} />
                <DataColumn header1={translationsStore.translate('tripsPanel.table.detail.journeyend')} value1={this.state.address2} />
                <DataColumn value1={new Date(summary.endAt).toLocaleTimeString([], {timeStyle: 'short'})} />
              </div>
            )}
            {!(positions && positions.length > 1) && <div />}
          </div>
        </div>
        {hasValidPosition && (
          <div className="map">
            <Map
              getLat={location => location.coordinates[1]}
              getLng={location => location.coordinates[0]}
              ref={this.MapRef}
              onTap={() => false}
              className="tripDetailMap"
              style={{
                height: '100%',
                right: '0',
                width: '100%'
              }}
              markers={markers}
              markersMapper={this.markersMapper}
              polyline={positions.length > 1 ? positions.map(([lng, lat]) => ({ lng, lat })) : markers.map(this.markersMapper)}
            />
          </div>
        )}
        {!hasValidPosition && <div>No positions available</div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/TripPanel/TripPanelTable/TripCarouselContent/TripCarouselContent.js